import {FC} from 'react';

import {orderColumns, useGetEventOrders} from '@entities/order';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';

import {PaginationState} from '@/shared/types';

const localStorageKey = 'eventOrdersTabV1';

const columns = orderColumns.filter(column => column.accessorKey !== 'eventId');

interface EventOrdersTabProps {
  eventSlug: string;
}

export const EventOrdersTab: FC<EventOrdersTabProps> = ({eventSlug}) => {
  const {urlState, setUrl} = useUrlState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const {
    data,
    isPending: isLoading,
    error,
  } = useGetEventOrders(
    {
      eventId: eventSlug,
      page: urlState.pageIndex + 1,
      pageSize: urlState.pageSize,
    },
    {enabled: Boolean(eventSlug)},
  );

  return (
    <MrTable
      columns={columns}
      data={data?.items ?? []}
      error={error}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      enablePagination
      manualPagination
      onPaginationChange={setUrl}
      rowCount={data?.total ?? 0}
      state={{
        isLoading,
        pagination: urlState,
      }}
      enableColumnPinning
      initialState={{
        columnPinning: {
          left: ['id'],
        },
      }}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
